import { SET_REF_TIME } from './actions/types'

const INITIAL_STATE = {
  refTime: null,
}

function setRefTime(state, action) {
  return {
    ...state,
    refTime: action.payload.time,
  }
}

function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_REF_TIME:
      return setRefTime(state, action)
    // TODO: add more action types if necessary
    default:
      break
  }

  return state
}

export default reducer
